import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerTitle), 1),
      _renderSlot(_ctx.$slots, "header-append", {}, undefined, true),
      _createElementVNode("img", {
        src: _ctx.closeIcon,
        alt: "close",
        class: "close-icon",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.cancel && this.cancel(...args)))
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: _normalizeClass([{ noPaddingTop: _ctx.noPaddingTop, 'fixed-content': _ctx.fixedSize }, "card-content-container"]),
        style: _normalizeStyle({ maxHeight: _ctx.contentMaxHeight })
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 6),
      (!_ctx.withoutBotNav)
        ? (_openBlock(), _createBlock(_component_BottomNavigation, {
            key: 0,
            cancel: _ctx.cancel,
            confirm: _ctx.confirm,
            confirmButtonDisabled: !_ctx.activeValidate,
            first: true,
            last: true,
            smallMarginRight: true,
            class: "bottom-nav"
          }, null, 8, ["cancel", "confirm", "confirmButtonDisabled"]))
        : _createCommentVNode("", true)
    ])
  ]))
}